import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { rulesBuilder } from 'scbk-shared-module/modules/Form';

export const tokensRulesBuilder = <T extends FieldValues>() => {
  const { t } = useTranslation();

  const builder = rulesBuilder<T>();

  return {
    ...builder,
    safeCardSeqValue() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.035', '보안카드번호는 필수 입력 항목입니다.');
        }

        return value.length === 3
          ? true
          : t('TokensComponent.036', '보안카드번호를 전부 입력해 주세요.');
      });
    },
    safeCardNumber1() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.053', '보안카드 앞 2자리를 입력해 주세요.');
        }

        return value.length === 2
          ? true
          : t('TokensComponent.054', '보안카드 앞 자리는 2자리로 입력해 주세요.');
      });
    },
    safeCardNumber2() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.055', '보안카드 뒤 2자리를 입력해 주세요.');
        }

        return value.length === 2
          ? true
          : t('TokensComponent.056', '보안카드 뒤 자리는 2자리로 입력해 주세요.');
      });
    },
    mOtpNumber() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.064', '모바일OTP 비밀번호를 입력해 주세요.');
        }

        return value.length === 6
          ? true
          : t('TokensComponent.065', '모바일OTP 비밀번호 6자리를  입력해 주세요.');
      });
    },
    otpNumber() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.058', 'OTP 번호를 입력해 주세요.');
        }

        return value.length === 6
          ? true
          : t('TokensComponent.059', 'OTP 번호 6자리를 입력해 주세요.');
      });
    },
    transPassword() {
      return builder.validate((v, ctx) => {
        const el = document.getElementById(ctx.name) as HTMLInputElement;
        const value = v !== '' ? v : (el?.value ?? '');

        if (value.length === 0) {
          return t('TokensComponent.041', '이체비밀번호를 입력해 주세요.');
        }

        return value.length >= 6
          ? true
          : t('TokensComponent.042', '이체비밀번호를 전부 입력해 주세요.');
      });
    },
    phoneNo1() {
      return builder
        .required(t('TokensComponent.050', '앞자리는 2자리 이상 입력해 주세요.'))
        .minLength(2, t('TokensComponent.050', '앞자리는 2자리 이상 입력해 주세요.'));
    },
    phoneNo2() {
      return builder
        .required(t('TokensComponent.051', '중간자리는 3자리 이상 입력해 주세요.'))
        .minLength(3, t('TokensComponent.051', '중간자리는 3자리 이상 입력해 주세요.'));
    },
    phoneNo3() {
      return builder
        .required(t('TokensComponent.052', '끝자리는 4자리 이상 입력해 주세요.'))
        .minLength(4, t('TokensComponent.052', '끝자리는 4자리 이상 입력해 주세요.'));
    },
  };
};
